export default __webpack_public_path__ + "static/media/Aleo-Italic.b7446a68.otf";